import {
    getJsonAsync,
    postJsonAsync
  } from 'shared/actions';
  import {toastr} from 'react-redux-toastr';
  import {initialize, reset} from 'redux-form';
  import {
    displayFinancialFeesList,
    displayDefaultTechFeeModalVisibility,
    displayTournamentTechFeeModalVisibility
  } from './actionTypes';

export const loadFinancialAccountFees = () => (dispatch) => {
    dispatch(getJsonAsync(`finance/gettechfees`))
        .then(data => {
        dispatch(displayFinancialFeesList(data));
        })
        .catch(() => { });
};

export const handleDefaultTechFeeEditClick = () => (dispatch, getState) => {
  
  const fee = getState().finance.fees.feesList.defaultTechnologyFee;

  dispatch(displayDefaultTechFeeModalVisibility(true));
  dispatch(initialize('groupTechFeeForm', {fee}));
  setTimeout(() => {
    // focus field after animatation finished (~800ms) by directly accessing the dom
    document.querySelectorAll('.modal-dialog #groupTechFeeForm [name=fee]')[0].focus();
  }, 800);
};

export const handleDefaultTechFeeModalCancel = () => dispatch => {
  dispatch(displayDefaultTechFeeModalVisibility(false));
  dispatch(reset('groupTechFeeForm'));
};

export const handleDefaultTechFeeModalSave = data => (dispatch) => new Promise((resolve, reject) => {
  
  dispatch(postJsonAsync(`finance/updatedefaulttechfee`, data))
  .then(() => {
    toastr.success('Saved!', 'Default technology fee successfully saved.');
    dispatch(displayDefaultTechFeeModalVisibility(false));
    dispatch(reset('groupTechFeeForm'));
    dispatch(loadFinancialAccountFees());
    resolve();
  })
  .catch(error => reject(error));
});

export const handleTournamentTechFeeEditClick = (tournamentId) => (dispatch, getState) => {
  const fee = getState().finance.fees.defaultTechFee;

  dispatch(displayTournamentTechFeeModalVisibility(true));
  dispatch(initialize('tournamentTechFeeForm', {fee, tournamentId}));
  
  setTimeout(() => {
    // focus field after animatation finished (~800ms) by directly accessing the dom
    document.querySelectorAll('.modal-dialog #tournamentTechFeeForm [name=fee]')[0].focus();
  }, 800);
};

export const handleTournamentTechFeeModalCancel = () => dispatch => {
  dispatch(displayTournamentTechFeeModalVisibility(false));
  dispatch(reset('tournamentTechFeeForm'));
};

export const handleTournamentTechFeeModalSave = data => (dispatch) => new Promise((resolve, reject) => {
  
  dispatch(postJsonAsync(`finance/updateTournamentTechFee`, data))
  .then(() => {
    toastr.success('Saved!', 'Tournament technology fee successfully saved.');
    dispatch(displayTournamentTechFeeModalVisibility(false));
    dispatch(reset('tournamentTechFeeForm'));
    dispatch(loadFinancialAccountFees());
    resolve();
  })
  .catch(error => reject(error));
});


// WEBPACK FOOTER //
// ./src/features/finance/fees/actions.js